import { FC } from 'react'
import { PreventiveService } from '@cms-max/medicare-api-sdk'
import { PreventiveServiceCard } from './PreventiveServiceCard'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { IconHeartClipboard } from 'components/Icon/IconHeartClipboard'
import { SortDirection } from 'models/preventive-services'
import orderBy from 'lodash.orderby'

export interface PreventiveServicesContentProps {
  data: PreventiveService[],
  emptyMessage: string,
  sortDirection: SortDirection
}

export const PreventiveServicesContent: FC<PreventiveServicesContentProps> = ({ data, emptyMessage, sortDirection }) => {
  const sortedData: PreventiveService[] = orderBy(data, (c) => new Date(c.availableDate).getTime(), sortDirection)

  return (
    <div>
      {(sortedData.length > 0) && (
        <>
          {sortedData.slice(0, sortedData.length).map((service, index) => (
            <PreventiveServiceCard key={index} service={service} className='ds-u-margin-y--2' />
          ))}
        </>
      )}
      {(sortedData.length === 0) && (
        <>
          <Alert role='alert' hideIcon={true} className='ds-u-margin-y--2'>
            <div className="ds-l-row ds-u-justify-content--center ds-u-align-items--center">
              <div className="ds-l-col--3 ds-l-sm-col--1 ds-u-padding-right--0">
                <IconHeartClipboard className='my-c-my-svg-icon--inline-block'/>
              </div>
              <div className="ds-l-col--12 ds-l-sm-col--11 ds-u-padding--0 ds-u-padding-left--2">
                <p className="ds-c-alert__text preventive-service-message">
                  <span>{emptyMessage}</span>
                </p>
              </div>
            </div>
          </Alert>
        </>
      )}
    </div>
  )
}
